"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBboxFace = void 0;
var utils_1 = require("../../../utils");
var bbox_1 = require("./bbox");
exports.IBboxFace = (0, utils_1.IRecord)({
    type: 'face',
    parent: (0, bbox_1.IBbox)()
});
